import { post,get } from "../http";
const play = {
    getvideobyid: params =>post('/app/live/getvideobyid.json',params),
    settings:params => post('/app/live/settings',params),
    roomrec:params => post('/app/live/roomrec.json',params),
    getMarks:params => post('/app/video/marks.json',params),
    getRecordStatus:params => post('/app/live/getRecordStatus.json',params),
    getPPt:params => post('/app/live/courseware.json',params),
    getPrecontent:params => post('/app/live/precontent.json',params),
    getAiPoints:params => post('/app/live/ai/key/point',params),
}
export default play;


// WEBPACK FOOTER //
// ./src/cmtapp/request/api/play.js